import axios from "axios";

import store from "../store";
import firebase from "../plugins/firebase";

const endpoint = "https://us-central1-api-springboard.cloudfunctions.net/";

const state = {
    profile: null
};

const mutations = {
    profile(state, payload) {
        state.profile = payload;
        if (payload.adminLevel > 3) {
            store.dispatch('app')
        } else {
            this.dispatch('logout')
            alert("Upp! Su cuenta no puede acceder, contacte al administrador y solicite nuevas credenciales")
        }
    },
};

const actions = {
    logout() {
        firebase
            .auth()
            .signOut()
            .then(() => {
                location.reload();
            });
    },
    login({ }, payload) {
        store.commit("loading", true)
        try {
            firebase
                .auth()
                .signInWithEmailAndPassword(payload.clientEmail, payload.clientPassword)
                .then(() => {

                }, error => {
                    store.commit("loading", false)
                    store.commit("messages", {
                        visible: true,
                        icon: "mdi-close",
                        text: error.message,
                        color: "red"
                    });
                }
                );
        } catch (error) {
            store.commit("loading", false)
            store.commit("messages", {
                visible: true,
                icon: "mdi-close",
                text: error.message,
                color: "red"
            });
        }
    },
    profile({ commit }) {
        store.commit("loading", true)
        axios
            .get(endpoint + "profileNoCache", {
                params: {
                    uid: firebase.auth().currentUser.uid,
                },
            })
            .then((response) => {
                commit("profile", response.data);

            }, error => {
                store.commit("loading", false)
                store.commit("messages", {
                    visible: true,
                    icon: "mdi-close",
                    text: error.message,
                    color: "red"
                });
            });
    }
};

const getters = {
    profile: (state) => state.profile
};


export default {
    getters,
    mutations,
    actions,
    state,
};